// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sideCart{
    position: fixed;
    top: 0;
    right: -400px;
    width: 400px;
    height: 100%;
    background-color: rgb(55, 55, 55);
    box-shadow: -2px 0 5px rgba(0,0,0,0.5);
    transition: right 0.3s ease;
    z-index: 1000;
    overflow: hidden;
}
.sideCart.open {
    right: 0;
}

.sideCart-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: white;
    padding: 20px;
    max-height: 60px;
}

.sideCart-content{
    height: calc(100% - 60px);
}`, "",{"version":3,"sources":["webpack://./src/Components/SideCart/SideCart.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,iCAAiC;IACjC,sCAAsC;IACtC,2BAA2B;IAC3B,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".sideCart{\n    position: fixed;\n    top: 0;\n    right: -400px;\n    width: 400px;\n    height: 100%;\n    background-color: rgb(55, 55, 55);\n    box-shadow: -2px 0 5px rgba(0,0,0,0.5);\n    transition: right 0.3s ease;\n    z-index: 1000;\n    overflow: hidden;\n}\n.sideCart.open {\n    right: 0;\n}\n\n.sideCart-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    color: white;\n    padding: 20px;\n    max-height: 60px;\n}\n\n.sideCart-content{\n    height: calc(100% - 60px);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
